import { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { updateUser, loadRoles } from "../../service/api_service";
import BorderWidget from "../widgets/border_widget";
import { Skeleton, Stack, Typography, useColorScheme } from "@mui/material";
import { Constants } from "../../utils/constants";
import MainSwitch from "../forms/main_switch";

function Notifications({ jobStore }) {
  useEffect(() => {
    jobStore.setNavigation("setting");
  }, [jobStore]);
  const { mode } = useColorScheme();
  const currentMode = mode || "system";
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(false);
  const [enableReports, setEnableReports] = useState(true);
  const [alert, setAlert] = useState(false);
  const [dailyDigest, setDailyDigest] = useState(false);

  useEffect(() => {
    if (!me) {
      return;
    }
    setEnableReports(
      me?.reporting_enabled || false
    );
    setAlert(
      me?.alert_notifications_enabled || false
    );
    setDailyDigest(
      me?.daily_digest_enabled || false
    );
  }, [me]);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      const roles_ = loadRoles(true);
      const { me, roles } = await roles_;
      setMe(me);
      setLoading(false);
    };
    fetch();
  }, []);

  const reportItem = ({
    title,
    description,
    value,
    onChange,
    noBorder = false,
  }) => {
    return (
      <Stack
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{
          borderBottom: !noBorder ? `1px solid ${Constants.Colors[currentMode].border}` : "none",
          paddingBlock: `calc(${Constants.Styles.spacing} * 5)`,
          paddingBottom: noBorder ? 0 : `calc(${Constants.Styles.spacing} * 5)`,
        }}
      >
        <Stack
        spacing={"0.125rem"}
        >
          {loading ? <Skeleton
            variant="rounded"
            width={100}
            height={20}
          /> : <Typography
            sx={{
              fontWeight: Constants.Styles.fontWeight.medium,
              fontSize: Constants.Styles.fontSize.sm,
              lineHeight: Constants.Styles.lineHeight.sm,
            }}
          >{title}</Typography>}
          {loading ? <Skeleton
            variant="rounded"
            width={200}
            height={20}
          /> : <Typography
            sx={{
              fontWeight: Constants.Styles.fontWeight.normal,
              fontSize: Constants.Styles.fontSize.xs,
              lineHeight: Constants.Styles.lineHeight.xs,
              color: Constants.Colors.light.mutedForeground,
            }}
          >{description}</Typography>}
        </Stack>
        {loading ? <Skeleton
          variant="rounded"
          width={40}
          height={20}
        /> : <MainSwitch
          value={value}
          onChange={onChange}
        />}
      </Stack>
    );
  }

  return (
    <BorderWidget
      sx={{
        boxShadow: "0px 1px 3px 0px #0000001a",
        padding: `calc(${Constants.Styles.spacing} * 6)`,
        borderRadius: `calc(${Constants.Styles.radius.base} + 4px)`,
      }}
    >
      <Typography sx={{
        fontWeight: Constants.Styles.fontWeight.medium,
        fontSize: Constants.Styles.fontSize.lg,
        lineHeight: Constants.Styles.lineHeight.lg,
      }}>Email Notifications</Typography>
      <Typography
        sx={{
          fontWeight: Constants.Styles.fontWeight.medium,
          fontSize: Constants.Styles.fontSize.sm,
          lineHeight: Constants.Styles.lineHeight.sm,
          color: Constants.Colors.light.mutedForeground,
          mt: "0.5rem",
        }}
      >
        Configure how your receive email updates
      </Typography>
      {reportItem({
        title: "Weekly Reports",
        description: "Receive a weekly summary of redirect activity",
        value: enableReports,
        onChange: (e) => {
          setEnableReports(e);
          const payload = {
            "reporting_enabled": e,
          }
          updateUser(payload);
        },
      })}
      {reportItem({
        title: "Alert Notifications",
        description: "Get notified when redirect thresholds are exceeded",
        value: alert,
        onChange: (e) => {
          setAlert(e);
          const payload = {
            "alert_notifications_enabled": e,
          }
          updateUser(payload);
        },
      })}
      {reportItem({
        title: "Daily Digest",
        description: "Receive a daily summary of new 404 pages detected",
        value: dailyDigest,
        onChange: (e) => {
          setDailyDigest(e);
          const payload = {
            "daily_digest_enabled": e,
          }
          updateUser(payload);
        },
        noBorder: true,
      })}
    </BorderWidget>
  );
}

export default observer(Notifications);
